module.exports = __webpack_public_path__ + "static/media/loader-light.923f7f4a.svg";